export const CONSTANTS = {
	map_center: [-89.40519332885742, 43.075085534225475],
	map_style: 'mapbox://styles/uwmadison-ucomm/cm4u97wim009n01qphja20qlu',
};
